import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const assetsDataManagerObjectDetailViewEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-assets-data-manager-object-classes-page", jiraSpaEntry: "async-assets-data-manager-object-detail-view-page" */ './src'
			),
	),
	getPreloadProps: () => ({}),
});
